import { render, staticRenderFns } from "./segmentation.vue?vue&type=template&id=719708d2&"
import script from "./segmentation.vue?vue&type=script&lang=js&"
export * from "./segmentation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('719708d2')) {
      api.createRecord('719708d2', component.options)
    } else {
      api.reload('719708d2', component.options)
    }
    module.hot.accept("./segmentation.vue?vue&type=template&id=719708d2&", function () {
      api.rerender('719708d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/segmentation.vue"
export default component.exports